import React, { Component } from 'react';
import { Alert } from "react-bootstrap";

export default class BetterAlerts extends Component {

    render() {
        const errors = Array.isArray(this.props.errors)
            ? this.props.errors.filter((msg) => typeof msg === "string" && msg.trim().length > 0)
            : [];

        const success = Array.isArray(this.props.success)
            ? this.props.success.filter((msg) => typeof msg === "string" && msg.trim().length > 0)
            : [];

        const warnings = Array.isArray(this.props.warnings)
            ? this.props.warnings.filter((msg) => typeof msg === "string" && msg.trim().length > 0)
            : [];

        if (errors.length === 0 && success.length === 0 && warnings.length === 0) {
            return null;
        }

        return (
            <div>
                {errors.map((msg, i) => (
                    <Alert key={`err-${i}`} variant="danger">{msg}</Alert>
                ))}

                {warnings.map((msg, i) => (
                    <Alert key={`warn-${i}`} variant="warning">{msg}</Alert>
                ))}

                {success.map((msg, i) => (
                    <Alert key={`ok-${i}`} variant="success">{msg}</Alert>
                ))}
            </div>
        );
    }
}